export interface Vec2 {
  x: number;
  y: number;
}

export function v(x: number, y: number): Vec2 {
  return { x, y };
}

export function vadd(a: Vec2, b: Vec2): Vec2 {
  return { x: a.x + b.x, y: a.y + b.y };
}

export function vsub(a: Vec2, b: Vec2): Vec2 {
  return { x: a.x - b.x, y: a.y - b.y };
}

export function vmul(a: Vec2, s: number): Vec2 {
  return { x: a.x * s, y: a.y * s };
}

export function vdiv(a: Vec2, s: number): Vec2 {
  return { x: a.x / s, y: a.y / s };
}

export function length(a: Vec2): number {
  return Math.hypot(a.x, a.y);
}

export function distance(a: Vec2, b: Vec2): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

export function clamp(x: number, min: number, max: number): number {
  return x < min ? min : x > max ? max : x;
}
